module.exports = __webpack_public_path__ + "static/changhui.lee-91b1f60f351f718e1fbf02c3b262c4d4.png";